import { ForgotPasswordForm } from "../components/forgot-password-form";

export default function ForgotPasswordPage() {
  return (
    <div className="h-full flex flex-col gap-7 items-center justify-center">
      <div className="space-y-2">
        <h1 className="text-xl font-semibold">
          Forgot Password
        </h1>
        <h2 className="text-sm text-neutral-600">
          Enter your email to reset your password
        </h2>
      </div>
      <ForgotPasswordForm />
    </div>
  );
}
